export default __webpack_public_path__ + "static/media/midsouth.d973876a.jpg";